/*===================================================================
=       FILE READER                   =
====================================================================*/
/**
 * File Reader
 */

import { FileUrl } from "../components/molecules/FileListManager/FileListManager";
import { FileDtoIn } from "../types/file.type";

/**
 * 
 * @param url 
 * @returns 
 */
export const getDataURLFromUrlFile = (url: string)=>{
 return new Promise((resolve, reject) => {

    fetch(url).then((res) => {

       res.blob().then((blob) =>{
        let reader = new FileReader();
        reader.addEventListener(
         "load",
         () => {
             resolve(reader.result)
         },
         false,
       );
        reader.readAsDataURL(blob)

       }
       
       ).catch(
        (err) => {
            reject(err)
        }
       )



    }).catch(
        (err) => {
            reject(err+' \n File not found \n');
        }
       )

 }) 
}


export const getDataFromUrlFile = (url: string)=>{
    return new Promise<string | ArrayBuffer | null>((resolve, reject) => {
   
       fetch(url).then((res) => {
   
          res.blob().then((blob) =>{
           let reader = new FileReader();
           reader.addEventListener(
            "load",
            () => {
                resolve(reader.result)
            },
            false,
          );
           reader.readAsDataURL(blob)
   
          }
          
          ).catch(
           (err) => {
               reject(err)
           }
          )
   
   
   
       }).catch(
           (err) => {
               reject(err+' \n File not found \n');
           }
          )
   
    }) 
   }

export const convertFileToFileDto = (file: FileUrl[]): Promise<FileDtoIn[]> => {
    return new Promise<FileDtoIn[]>((resolve, reject) => {

        if(file.length === 0){
            resolve([])
        }
        let fileDtoIn: FileDtoIn[] = []
        file.forEach((f) => {
            const ignore = f.url === undefined ? false : true
            if(ignore){
                fileDtoIn.push({
                    filetype: f.type,
                    filename: f.name,
                    data_uri: "",
                    ignore: true
           
                })
                if (fileDtoIn.length === file.length) {
                    resolve(fileDtoIn)
                }
                
            }else{
                const reader = new FileReader();
                reader.onload = (e) => {
                    fileDtoIn.push({
                        filetype: f.type,
                        filename: f.name,
                        data_uri: e.target?.result as string,
               
                    })
                    if (fileDtoIn.length === file.length) {
                        resolve(fileDtoIn)
                    }
                }
                reader.readAsDataURL(f)
            }

        })
    }
    )
}

const BASE_URL = process.env.REACT_APP_URL_BACKEND
export const getFileUrlFromId = (id: string) => {
    return `${BASE_URL}/api/v2/compta/files/${id}`
}